/**
 * アサイン一覧からの登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

const allocate_entry_driver_assign = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index({ commit }, { driver_id, target_date }) {
      const params = {
        target_date: target_date
      }
      const api_path = `${API_PATH}/${driver_id}/assigns`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { driver_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/assigns`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          if (data.result.code) {
            commit('snackbar/showError', { message: data.result.message }, { root: true })

          } else {
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          }
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}
export default allocate_entry_driver_assign

